import { ListingSearchRoomItemProps } from './ListingSearchGuestInterface';
import ListingSearchGuestItem from './SearchGuestItem';
import { GuestScrollWrapper } from './SearchGuestStyle';

const ListingSearchRoomItem: React.FC<ListingSearchRoomItemProps> = (props) => {
  const {
    childGuestCount,
    adultGuestCount,
    childrenList,
    handleChildNumberIncrement,
    handleChildNumberDecrement,
    handleAdultNumberIncrement,
    handleAdultNumberDecrement,
    changeChildAge,
    isSingleLineDatePicker = false,
  } = props;

  return (
    <GuestScrollWrapper isOverflow={Boolean(childGuestCount)}>
      <ListingSearchGuestItem
        title='Yetişkin'
        subTitle='15+ Yaş'
        handleDecrement={handleAdultNumberDecrement}
        handleIncrement={handleAdultNumberIncrement}
        count={adultGuestCount}
        min={1}
      />

      <ListingSearchGuestItem
        isSingleLineDatePicker={isSingleLineDatePicker}
        title='Çocuk'
        subTitle='0-15 Yaş'
        handleDecrement={handleChildNumberDecrement}
        handleIncrement={handleChildNumberIncrement}
        count={childGuestCount}
        isChildCounter={true}
        childrenList={childrenList}
        changeChildAge={changeChildAge}
      />
    </GuestScrollWrapper>
  );
};

export default ListingSearchRoomItem;
